import { Model } from '@vuex-orm/core'
import CustomClass from '../../class/models/Class'

export default class Auth extends Model {
  static entity = 'auths'

  static fields() {
    return {
      id: this.string(),
      email: this.attr(null),
      username: this.string(''),
      first_name: this.string(''),
      last_name: this.attr(null),
      classes: this.hasMany(CustomClass, 'teacher_id'),
      profile: this.attr(null),
      school_name: this.attr(null),
      acara_id: this.attr(null),
      role: this.string(''),
      school_metadata: this.attr(null),
      type: this.string(''),
      name: this.attr(null),
      active_students: this.attr(null),
      student_meta: this.attr(null),
      individual_meta: this.attr(null),
      parent: this.attr(null),
      parent_id: this.attr(null)
    }
  }
}
